<a class="profile" routerLink="/profile" routerLinkActive="active" data-test="shell-header-profile-link">
    <app-avatar [label]="initials()" />
    <span class="identity">
        <span class="name">{{ name() || ('sidebar.profile' | translate) }}</span>
        @if (profile()?.email; as email) {
            <span class="email">{{ email }}</span>
        }
    </span>
</a>

<button type="button" class="item" (click)="themeService.toggle()" data-test="shell-header-theme-toggle">
    <app-icon [name]="themeService.theme() === 'dark' ? 'sun' : 'moon'" />
    <span>{{ (themeService.theme() === 'dark' ? 'sidebar.theme.light' : 'sidebar.theme.dark') | translate }}</span>
</button>

<a class="item" routerLink="/auth/logout" data-test="shell-header-logout">
    <app-icon name="log-out" />
    <span>{{ 'sidebar.logout' | translate }}</span>
</a>
